var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "tree_box"
  }, [_c("el-tree", {
    attrs: {
      data: _vm.treeData,
      "render-content": _vm.renderContent,
      "node-key": "id",
      "default-expand-all": true
    }
  }), _c("el-dialog", {
    attrs: {
      width: "700px",
      visible: _vm.dialogVisible,
      title: _vm.$t("下拉数据配置"),
      modal: false
    },
    on: {
      "update:visible": function ($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "form",
    attrs: {
      model: _vm.form,
      "label-width": "80px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: _vm.$t("字典值")
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "80%"
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: _vm.$t("值标识")
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "80%"
    },
    model: {
      value: _vm.form.value,
      callback: function ($$v) {
        _vm.$set(_vm.form, "value", $$v);
      },
      expression: "form.value"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer"
  }, [_c("el-button", {
    on: {
      click: _vm.saveItem
    }
  }, [_vm._v("确定")]), _c("el-button", {
    on: {
      click: function ($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };